import { Globe, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

const languages = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिंदी" },
  { code: "bho", label: "भोजपुरी" },
];

export const AavedakShell = ({ children, session, language, onLanguageChange, onLogout }) => {
  return (
    <div className="aavedak-app-shell" data-testid="aavedak-app-shell">
      <header className="aavedak-top-nav" data-testid="aavedak-top-nav">
        <div className="aavedak-logo-wrap">
          <div className="aavedak-logo-mark">A</div>
          <div>
            <p className="aavedak-logo-text" data-testid="aavedak-logo-text">Aavedak</p>
            <p className="aavedak-logo-sub" data-testid="aavedak-logo-sub">AI Grievance Platform</p>
          </div>
        </div>

        <div className="aavedak-nav-right">
          <div className="lang-chip" data-testid="language-chip">
            <Globe className="h-4 w-4" /> भाषा
          </div>
          {languages.map((item) => (
            <button
              key={item.code}
              className={`lang-btn ${language === item.code ? "active" : ""}`}
              onClick={() => onLanguageChange(item.code)}
              data-testid={`language-toggle-${item.code}`}
            >
              {item.label}
            </button>
          ))}

          <div className="session-pill" data-testid="session-pill">
            <span className="session-role">{session?.role || "guest"}</span>
            <span className="session-id">{session?.identifier || "-"}</span>
          </div>

          <Button
            className="logout-btn"
            onClick={onLogout}
            data-testid="shell-logout-button"
          >
            <LogOut className="h-4 w-4" /> Logout
          </Button>
        </div>
      </header>

      <main className="aavedak-page-main" data-testid="aavedak-page-main">
        {children}
      </main>
    </div>
  );
};
